module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/13-9bb88fadd46a8273d04fc1ab27979a37.png";